import { Provider, Type } from '@angular/core';

export function provideUserTrackingLegacy(service: Type<UserTrackingPreferencesServiceLegacy>): Provider[] {
  return [
    {
      provide: UserTrackingPreferencesServiceLegacy,
      useClass: service,
    },
  ];
}

export abstract class UserTrackingPreferencesServiceLegacy {
  abstract getUser(): {
    id: string;
    email: string;
  } | null;

  /**
   * Defines the base properties that should be included with every tracking event.
   */
  abstract getBaseProperties(): Array<{ key: string; value: string }>;

  /**
   * Defines the context
   * TODO clarify if this is even necessary? why not just pass this stuff in the props
   */
  abstract getBaseContext(): Record<string, unknown> | null;
}
